(() => {
  function initialize(root) {
    root.querySelectorAll('[data-atk-event]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      section.addEventListener('click', async event => {
        const button = event.target.closest('[data-event-copy]');
        if (!button) return;
        const label = button.querySelector('[data-copy-label]');
        const idleLabel = button.dataset.copyIdleLabel ||= label.textContent;
        clearTimeout(button._copyFeedbackTimer);
        try {
          await navigator.clipboard.writeText(button.dataset.eventCopy);
          label.textContent = 'Copied!';
        } catch (_) {
          label.textContent = 'Copy manually';
        }
        button._copyFeedbackTimer = setTimeout(() => {
          label.textContent = idleLabel;
        }, 2000);
      });
      if (section.dataset.motion !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('event-entered', 'event-motion-visible');
          observer.unobserve(entry.target);
        });
      }, {threshold: 0.12});
      section.querySelectorAll('.event-heading, .event-prize, .event-step, .event-coupon, .event-extra').forEach(el => observer.observe(el));
      section._eventObserver = observer;
    });
  }
  initialize(document);
  if (!window.atkEventEditorBound) {
    window.atkEventEditorBound = true;
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-atk-event]').forEach(section => section._eventObserver?.disconnect());
    });
  }
})();
